import ButtonImport from './src/main'

ButtonImport.install = function (Vue) {
    Vue.components(ButtonImport.name, ButtonImport)
}

export default ButtonImport